import React from "react";
import { ASSETS } from "@/data/content";

/**
 * Full-width brand banner shown directly beneath the navigation, ahead of the hero.
 * Padding-top clears the fixed nav (80px at rest).
 */
export const Banner = () => (
  <section id="top" aria-label="Beyond the Engagement Score" className="bg-white pt-20" data-testid="intro-banner">
    <img
      src={ASSETS.banner}
      alt={ASSETS.bannerAlt}
      className="block h-auto w-full"
      width="1920"
      height="720"
      fetchPriority="high"
      decoding="async"
      data-testid="intro-banner-image"
    />
  </section>
);
